const Survey = {
  Survey: "Survey.Survey",
  GoToSurvey: "Survey.GoToSurvey",
  FillOutForm: "Survey.FillOutForm",
  SelectionPanelHeader: "Survey.SelectionPanelHeader",
  SelectionPanelSubHeader: "Survey.SelectionPanelSubHeader",
  NumberOfRemainingQuestions: "Survey.NumberOfRemainingQuestions",
  LastDateToAnswer: "Survey.LastDateToAnswer",
  AnnualReport: "Survey.AnnualReport",
  SaveSuccessMessage: "Survey.SaveSuccessMessage",
  SubmitSuccessMessage: "Survey.SubmitSuccessMessage",
  ForwardSuccessMessage: "Survey.ForwardSuccessMessage",
  SnoozeSurvey: "Survey.SnoozeSurvey",
  InfoMessage: "Survey.InfoMessage",
  BookAdvisoryBooking: "Survey.BookAdvisoryBooking",
  }
export default Survey;